import React, { useEffect, useState } from "react";
import p_nav_previous from "../../Assets/Images/p_nav_previous.svg";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../Services/axios";
import Lottie from "lottie-react";
import empotyLottie from "../../Assets/lottieFiles/emptybox.json"
import { showToast } from "../../Components/toastConfig/ToastConfig";
import NodeaxiosInstance from "../../Services/nodeaxios";
const Redeemed = () => {
    const navigate = useNavigate()
    const [redeemlist, setRedeemlist] = useState([])
    useEffect(() => {
        getHistroy()
    }, []);
    const getHistroy = async () => {
        try {
            NodeaxiosInstance.get('/profile/get-referral-loyalty-offer-redeem-history')
                .then((res) => {
                    setRedeemlist(res.data)
                })
        }
        catch (err) {
            if (err.response?.status == 400 || err.response?.status == 500) {
                showToast(err.response.data.message || "Something went wrong. Please try again.");
            }
        } finally {
            console.log("Referral loyalty history API call completed");
        }
    }
    return (
        <>
            <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white">
                <div className="d-flex justify-content-between align-items-center ms-2 me-2">
                    <img
                        src={p_nav_previous}
                        width={"24px"}
                        height={"16px"}
                        alt="Previous Button"
                        role="button"
                        onClick={() => navigate(-1)}
                    />
                    <div className="ff-balooPaaji2-bold fs-20 ms-2 ps-1">
                        Redeemed items
                    </div>
                </div>
            </div>
            <div className="scroller-style-y white-bg ">
                <div className="p-3 ">
                    {
                        redeemlist?.redeem_detail?.length > 0 ?
                            redeemlist.redeem_detail?.map((list) => {

                                return (
                                    <div className="d-flex mt-2 mb-2 rounded pigleUserIconEarned" onClick={() => navigate('/RedeemedDetails', { state: { purchaseid: list.purchase_id } })}>
                                        <div className="position-relative d-inline-block">
                                            <img
                                                src={list.offer_detail.offer_images[0]}
                                                height="90px"
                                                width="100px"
                                                alt="PLIcon"
                                                className="rounded-start"
                                            />

                                            <div
                                                className="position-absolute bottom-0 start-0 w-100 text-center fs-14 ff-poppins-regular text-white loyaltyStatus "
                                                style={{
                                                    backgroundColor:
                                                        list.deleverystatus === "2" ? "#f7b924" : "#16aaff",
                                                }}
                                            >
                                                {list.deleverystatus === "2" ? "Shipped" : "Processing"}
                                            </div>
                                        </div>

                                        <div className=" d-flex justify-content-center flex-column align-items-center">
                                            <div className="w-100 px-2">
                                                <p className="m-0 ff-poppins-bold fs-14 elipseLoyalty">
                                                    {list.offer_detail.offer_name}
                                                </p>
                                                <p className="m-0 ff-poppins-regular secondary-text fs-12  singleline-text">
                                                    {list.offer_detail.offfer_description}
                                                </p>
                                                <p className="m-0 ff-poppins-regular fs-12 elipseLoyalty"> {list.delivery_status == "3" ? "Delivered" : "Delivery"} on
                                                    <span> {new Date(list.delivery_date.substring(0, 10)).toDateString().substring(4, 20)}  </span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                            :
                            <div className="d-flex justify-content-center align-items-center h-100">
                                <div className="">
                                    <Lottie animationData={empotyLottie} />
                                    <p className="fs-12 ff-poppins-semiBold text-center ">No redeemed items yet </p>
                                </div>
                            </div>
                    }
                </div>
            </div>
        </>
    )
}
export default Redeemed